<div id="step3" appAppear (event)="anim = true">
  <div class="miniCarousel">
    <div class="one" [ngClass]="{ anim: 'active' }">
      @for (video of miniVideos.top; track $index) {
        <div class="videoItem">
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="30" fill="#504F4F" />
            <path
              d="M41.8176 29.2294L24.3756 40.5169L23.3214 19.7679L41.8176 29.2294Z"
              fill="white" />
          </svg>
          <video
            [routerLink]="['/browse/watch', video.id]"
            class="miniVideo"
            loop
            muted
            playsinline
            inline
            (mouseover)="hoverMiniVideo($event)"
            (mouseout)="hoverMiniVideo($event)"
            [poster]="
              'assets/images/fallback/mini-carousel/' + video.name + '.jpg'
            ">
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.webm'
              "
              type="video/webm" />
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.mp4'
              "
              type="video/mp4" />
          </video>
        </div>
      }
      @for (video of miniVideos.bottom; track $index) {
        <div class="videoItem">
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="30" fill="#504F4F" />
            <path
              d="M41.8176 29.2294L24.3756 40.5169L23.3214 19.7679L41.8176 29.2294Z"
              fill="white" />
          </svg>
          <video
            [routerLink]="['/browse/watch', video.id]"
            class="miniVideo"
            loop
            muted
            playsinline
            (mouseover)="hoverMiniVideo($event)"
            (mouseout)="hoverMiniVideo($event)"
            [poster]="
              'assets/images/fallback/mini-carousel/' + video.name + '.jpg'
            ">
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.webm'
              "
              type="video/webm" />
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.mp4'
              "
              type="video/mp4" />
          </video>
        </div>
      }
    </div>
    <div class="two" [ngClass]="anim ? 'active' : ''">
      @for (video of miniVideos.bottom; track $index) {
        <div class="videoItem">
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="30" fill="#504F4F" />
            <path
              d="M41.8176 29.2294L24.3756 40.5169L23.3214 19.7679L41.8176 29.2294Z"
              fill="white" />
          </svg>
          <video
            [routerLink]="['/browse/watch', video.id]"
            class="miniVideo"
            loop
            muted
            playsinline
            (mouseover)="hoverMiniVideo($event)"
            (mouseout)="hoverMiniVideo($event)"
            [poster]="
              'assets/images/fallback/mini-carousel/' + video.name + '.jpg'
            ">
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.webm'
              "
              type="video/webm" />
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.mp4'
              "
              type="video/mp4" />
          </video>
        </div>
      }
      @for (video of miniVideos.top; track $index) {
        <div class="videoItem">
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="30" fill="#504F4F" />
            <path
              d="M41.8176 29.2294L24.3756 40.5169L23.3214 19.7679L41.8176 29.2294Z"
              fill="white" />
          </svg>
          <video
            [routerLink]="['/browse/watch', video.id]"
            class="miniVideo"
            loop
            muted
            playsinline
            (mouseover)="hoverMiniVideo($event)"
            (mouseout)="hoverMiniVideo($event)"
            [poster]="
              'assets/images/fallback/mini-carousel/' + video.name + '.jpg'
            ">
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.webm'
              "
              type="video/webm" />
            <source
              [src]="
                'https://d2z7yiz3wla4oq.cloudfront.net/videos/' +
                video.name +
                '.mp4'
              "
              type="video/mp4" />
          </video>
        </div>
      }
    </div>
  </div>
</div>
